__turbopack_context__.v({
  "bazaarvoice-review-section": "bazaarvoice-review-section-component-module-scss-module__jKVFhq__bazaarvoice-review-section",
  "bazaarvoice-review-section__headline": "bazaarvoice-review-section-component-module-scss-module__jKVFhq__bazaarvoice-review-section__headline",
  "bazaarvoice-review-section__no-matching-reviews": "bazaarvoice-review-section-component-module-scss-module__jKVFhq__bazaarvoice-review-section__no-matching-reviews",
  "bazaarvoice-review-section__reviews": "bazaarvoice-review-section-component-module-scss-module__jKVFhq__bazaarvoice-review-section__reviews",
});
